import { useState } from "react";

import { Button, ScrollArea, Textarea, TextInput } from "@mantine/core";

import { MAX_TEXT_LENGTH, MAX_VARCHAR_LENGTH } from "../../constants/constants.ts";
import { useMailCreation } from "../../hooks/useMailCreation.ts";
import classes from "../../styles/components/forms/MailForm.module.scss";
import EmailInCcsInput from "./EmailInCcsInput.tsx";

export const MailForm = () => {
  const { formData, handleSubmit, handleChange, errors } = useMailCreation();
  const isSubmitDisabled = !!errors.senderEmail || !!errors.receiverEmail;
  const [isCCsEnabled, setIsCCsEnabled] = useState(false);
  const [isBCCsEnabled, setIsBCCsEnabled] = useState(false);
  const toggleCCs = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setIsCCsEnabled((prev) => !prev);
  };
  const toggleBCCs = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setIsBCCsEnabled((prev) => !prev);
  };
  return (
    <form onSubmit={handleSubmit}>
      <TextInput
        className={classes.input}
        required
        label="From"
        value={formData.senderEmail}
        placeholder="your@email.com"
        maxLength={MAX_VARCHAR_LENGTH}
        onChange={(event) => handleChange("senderEmail", event.currentTarget.value)}
        error={errors.senderEmail}
      />
      <TextInput
        className={classes.input}
        required
        label="To"
        placeholder="target@email.com"
        value={formData.receiverEmail}
        maxLength={MAX_VARCHAR_LENGTH}
        onChange={(event) => handleChange("receiverEmail", event.currentTarget.value)}
        error={errors.receiverEmail}
      />
      <div>
        <a
          hidden={isCCsEnabled}
          onClick={toggleCCs}
          style={{ cursor: "pointer", color: "grey", paddingRight: "1%" }}
        >
          CCs
        </a>
        <a hidden={isBCCsEnabled} onClick={toggleBCCs} style={{ cursor: "pointer", color: "grey" }}>
          BCCs
        </a>
      </div>
      {isCCsEnabled ? (
        <EmailInCcsInput
          label={"CCs"}
          onChange={(emails) => handleChange("ccs", emails)}
          value={formData.ccs || []}
        />
      ) : (
        <></>
      )}
      {isBCCsEnabled ? (
        <EmailInCcsInput
          label={"BCCs"}
          onChange={(emails) => handleChange("bccs", emails)}
          value={formData.bccs || []}
        />
      ) : (
        <></>
      )}
      <TextInput
        className={classes.input}
        required
        label="Subject"
        value={formData.subject}
        maxLength={MAX_VARCHAR_LENGTH}
        onChange={(event) => handleChange("subject", event.currentTarget.value)}
      />
      <Textarea
        required
        rows={5}
        className={classes.input}
        label="Body"
        value={formData.body}
        maxLength={MAX_TEXT_LENGTH}
        onChange={(event) => handleChange("body", event.currentTarget.value)}
      >
        <ScrollArea />
      </Textarea>
      <Button className={classes.button} type="submit" disabled={isSubmitDisabled}>
        Submit
      </Button>
    </form>
  );
};
